<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="content">
      <div
        v-if="false"
        class="tip"
      >
        <p v-if="!!accountInfo['combo']">
          当前套餐：
          <!-- <span v-for="(v,k) in accountInfo['combo']" :key="k"> {{`${v.type==1&&'关键人定位'||'采购商查询'}-${v.title}`}}</span> -->
          <ul>
            <li
              v-for="(v,k) in accountInfo['combo']"
              :key="k"
            >
              <span> {{`${v.type==1&&'关键人定位'||'采购商查询'}-${v.title}`}}</span>
            </li>
          </ul>
        </p>
        <template v-else>
          尊敬的用户，您好！您当前未购买套餐，请完成套餐充值！
        </template>
      </div>
      <div
        v-if="false"
        style="text-align: right;margin-top: -10px;margin-bottom: -20px;z-index: 1;"
      >
        <a-tooltip placement="bottomRight">
          <template slot="title">
            <div>
              <div>
                <div class="product-type">关键人定位</div>
                <p>
                  <span> 9.99元/周会员套餐 </span>
                  <ul>
                    <li>1、套餐在支付后即时生效，有效期截止至购买日起第7日当天同一时间（以支付成功时间为准）；</li>
                    <li>2、在套餐有效期内，用户每日可查询数据总量200条；</li>
                    <li>3、查询后的数据可通过收藏操作保存至会员中心-我的关键人账户中；</li>
                    <li>4、会员中心账户中的查询数据可随时查询使用，不做额外收费。</li>
                  </ul>
                </p>
              </div>
              <div>
                <div class="product-type">采购商数据查询</div>
                <p>
                  <span> 2999元/年会员套餐 </span>
                  <ul>
                    <li>1、套餐在支付后即时生效，有效期截止至购买日起次年当天同一时间（以支付成功时间为准）；</li>
                    <li>2、在套餐有效期内，用户每日可查询数据总量100条； </li>
                    <li>3、查询后的数据可通过关注操作收藏至会员中心-我的采购商账户中； </li>
                    <li>4、会员中心账户中的查询数据可随时查询使用，不做额外收费； </li>
                    <li>5、可享受关键人定位套餐权益内服务，有效期为一年。 </li>
                  </ul>
                </p>
                <p>
                  <span> 299元/月会员套餐</span>
                  <ul>
                    <li>1、套餐在支付后即时生效，有效期截止至购买日起次月当天同一时间（以支付成功时间为准）；</li>
                    <li>2、在套餐有效期内，用户每日可查询数据总量80条； </li>
                    <li>3、查询后的数据可通过关注操作收藏至会员中心-我的采购商账户中； </li>
                    <li>4、会员中心账户中的查询数据可随时查询使用，不做额外收费； </li>
                    <li>5、可享受关键人定位套餐权益内服务，有效期一个月。 </li>
                  </ul>
                </p>
                <p>
                  <span> 99元/周会员套餐</span>
                  <ul>
                    <li>1、套餐在支付后即时生效，有效期截止至购买日起第7日当天同一时间（以支付成功时间为准）；</li>
                    <li>2、在套餐有效期内，用户每日可查询数据总量60条； </li>
                    <li>3、查询后的数据可通过关注操作收藏至会员中心-我的采购商账户中； </li>
                    <li>4、会员中心账户中的查询数据可随时查询使用，不做额外收费。 </li>
                  </ul>
                </p>
              </div>

            </div>
          </template>
          <span class="help">
            <a-icon type="question-circle" /> 点此了解套餐及资费说明
          </span>
        </a-tooltip>
      </div>
      <template >
        <s-exhibitor ></s-exhibitor>
      </template>
      <div
        v-if="false"
        style="text-align: center;"
      >
        <a-button
          @click="recharge"
          style="text-align: center;margin-top: 50px;width: 180px;border-radius: 0;"
          size="large"
          type="primary"
        >现在充值</a-button>
      </div>
      <div class="recommended-service">
        <span>服务推荐</span>
        <ul :class="{ 'hide-purchaser': VUE_APP_HIDE_PURCHASER == 'true'}">
          <li>
            <b>国外展会名录：</b>
            <p>根据展会名称或公司名称，搜索10000场展会的300万展会名录，获取企业基本信息、联系人、参展记录。</p>
            <a href="/buyerfinder/?st=2">点击体验
              <a-icon type="right-circle" /></a>
          </li>
          <li v-if="VUE_APP_HIDE_PURCHASER != 'true'">
            <b>国外采购商：</b>
            <p>根据采购产品名称或公司名称进行查询，获取全球采购商的相关信息，贸易快人一步。</p>
            <a href="/buyerfinder/?st=0">点击体验
              <a-icon type="right-circle" /></a>
          </li>
          <li>
            <b>国际展会咨询</b>
            <p>了解境外展会信息，订展、参展一步搞定。</p>
            <a
              target="_blank"
              href="http://www.showguide.cn"
            >点击体验
              <a-icon type="right-circle" /></a>
          </li>
        </ul>
      </div>
    </div>
  </a-layout-content>
</template>
<script>
import Banner from "./banner";
import Login from "../Login";
import Registered from "./Dashboard/Registered";
import Exhibitor from "./Dashboard/Exhibitor";
import HidePurchaser from "./Dashboard/HidePurchaser";
import Vue from "vue";
export default {
  components: {
    "s-banner": Banner,
    "s-registered": Registered,
    "s-exhibitor": Exhibitor,
    "s-hide-purchaser": HidePurchaser
  },
  data() {
    console.log(process.env.VUE_APP_HIDE_PURCHASER);
    return {
      VUE_APP_HIDE_PURCHASER: process.env.VUE_APP_HIDE_PURCHASER
    };
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    recharge() {
      this.$router.push({ name: "recharge" });
    }
  },
  created() {
    this.$refreshAccountInfo();
  }
};
</script>
<style lang="scss" >
.ant-tooltip-placement-bottomRight {
  max-width: 1000px;
}
</style>
<style lang="scss" scoped>
.content {
  .recommended-service {
    margin-top: 30px;
    width: 100%;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    & > span {
      display: block;
      width: 100px;
      height: 30px;
      margin: -12px auto 0;
      text-align: center;
      background: #fff;
      font-size: 18px;
      color: #666;
    }
    & > ul {
      list-style: none;
      padding: 1px;
      li {
        font-size: 13px;
        & > p {
          margin-top: 5px;
          font-size: 12px;
          color: #666;
          height: 50px;
        }
        & > a {
          font-size: 14px;
          color: #008cd6;
          text-decoration: underline;
        }
        display: inline-block;
        width: 300px;
        margin: 0 8px;
        vertical-align: top;
        padding: 20px 30px;
        &:not(:last-child) {
          border-right: 1px solid #eaeff3;
        }
      }
    }
    & > ul.hide-purchaser {
      li {
        width: 474px;
        margin-left: 0;
        margin-right: 0;
        padding-left: 45px;
        padding-right: 65px;
      }
    }
  }
}
.tip {
  border: 1px solid #ecf0f3;
  height: 60px;
  text-align: center;
  line-height: 60px;
  color: #f00;
  border-image: linear-gradient(to right, white, #ecf0f3, white) 1 1;
  margin: 20px auto;
  width: 100%;
  & > p {
    margin: 0;
    width: 100%;
    font-size: 18px;
    color: #333;
    & > ul {
      padding: 0;
      display: inline-block;
      vertical-align: top;
      list-style: none;
      & > li {
        display: inline-block;
        margin: 0 10px;
        & > span {
          color: #f00;
        }
      }
    }
  }
}
.help {
  font-size: 12px;
  // float: right;
  color: #999;
}
.ant-tooltip-content {
  .product-type {
    text-align: center;
    color: #51c1ec;
  }
  p {
    padding-left: 20px;
    span {
      font-weight: bold;
    }
    ul {
      list-style: none;
      padding-left: 0;
    }
  }
}
</style>

